import ExamCreationFromStock from './components/ExamCreationFromStock.vue'

export default {
  elementId: 'exam-creation-from-stock',
  rootComponent: ExamCreationFromStock,
  stores: [
    {
      key: ['ExamCreationFromStock'],
      module: {}
    }
  ],
}
